import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/facility-account/list-accounts`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccountsFee: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/facility-account/fee-config/account-list`, {
      ...parameters,
    });
  },
  /**
   * Fetch the All Accounts list
   */
  fetchAllAccounts: (): Promise<any> => {
    return getRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/list-account-ids`,
      {},
    );
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccountsListFilters: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/facility-account/list-filters`);
  },
  /**
   * Get the all data for export the Accounts list without pagination
   * @param query
   * @returns
   */
  exportData: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/export-accounts`,
      { ...parameters },
    );
  },
  /**
   * Fetch single Accounts list with pagination
   */
  fetchOneAccounts: (query: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/facility-user/${query}`, {});
  },
  /**
   * create the Accounts list with pagination
   */
  createAccounts: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/create-fo`,
      parameters,
      true,
    );
  },
  /**
   * Edit the account function
   * @param id
   * @param data
   * @returns
   */
  editAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/edit-account/${id}`,
      { ...parameters },
      true,
    );
  },
  /**
   * Approved the account function
   * @param id
   * @param data
   * @returns
   */
  approvedAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/verify-account/${id}`,
      { ...parameters },
    );
  },

  /**
   * Approved password reset function
   * @param id - The facility user ID
   * @param data - The payload (e.g., { newPassword: 'yourPassword' })
   * @returns Promise<any>
   */
  facilityRestPassword: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-user/reset-password/${id}`,
      data,
    );
  },

  /**
   * Approved password reset function
   * @param id - The facility user ID
   * @param data - The payload (e.g., { newPassword: 'yourPassword' })
   * @returns Promise<any>
   */
  utilityRestPassword: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.accountApiUrl}api/super-admin/v1/utility-provider/reset-password/${id}`,
      data,
    );
  },

  /**
   * Delete the account api call function
   * @param data
   * @returns
   */
  deleteAccount: (id: String): Promise<any> => {
    return deleteRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/delete-account/${id}`,
    );
  },

  /**
   * show for the Revenue and Admin share and facility share data
   * @param query
   * @returns
   */
  fetchConsolidatedRevenue: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/consolidated-revenue`,
      { ...parameters },
    );
  },

  /**
   * Fetch single Accounts list with pagination
   */
  fetchFacilityAccount: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/facility-account/${id}`,
      { ...parameters },
    );
  },

  /**
   *  Fetch Power Consumed Graph Data Reports
   */
  fetchPowerConsumedGraph: (id: string, query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/paid-charging-transaction/${id}`,
      { ...parameters },
    );
  },
  /**
   *  Fetch Revenue Payable Graph Data Reports
   */
  fetchRevenuePayable: (id: string, query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/revenue-payout-master/${id}`, {
      ...parameters,
    });
  },
  /**
   * Fetch Device Count Report
   */
  fetchDeviceCountReport: (id: string, query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-count-report-by-facility/${id}`,
      { ...parameters },
    );
  },
  /**
   * Fetch Device Table Report
   */
  fetchDeviceListReport: (id: string, query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-list-by-facility/${id}`,
      { ...parameters },
    );
  },
  /**
   * Fetch Device Table Report
   */
  fetchStationListReport: (id: string, query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station//device-count/${id}`,
      { ...parameters },
    );
  },
  /**
   * Create Revenue Paout History
   */
  createRevenuePayoutHistory: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout-history/create/${id}`,
      parameters,
    );
  },
  /**
   * Create Revenue Paout History
   */
  createRevenuePayoutStripe: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/transfer/amount/${id}`,
      parameters,
    );
  },
  /**
   * Fetch Payout List Reports
   */
  fetchPayoutListReports: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout-history/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch Payout Export Data
   */
  fetchPayoutExportData: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout-history/export-data/${id}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch Payout List Filters
   */
  fetchPayoutListFilters: (): Promise<any> => {
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout-history/get/list-filters`,
    );
  },

  /**
   * Fetch Revenue By Transaction List Reports
   */
  fetchRevenueByTransactionList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-transaction`, {
      ...parameters,
    });
  },

  /**
   *Fetch Revenue By Transaction Export Data
   */
  fetchByTransactionExportData: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-transaction/export`, {
      ...parameters,
    });
  },

  /**
   * Fetch Revenue By Transaction List Filters
   */
  fetchByTransactionListFilters: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch Revenue By Month List Reports
   */
  fetchRevenueByMonthList: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction-revenue/by-month/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch Revenue By Month Export Data
   */
  fetchByMonthExportData: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction-revenue/by-month/export/${id}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch Account Details data show
   */
  fetchAccountDetails: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/account/${id}`, {
      ...parameters,
    });
  },
  /**
   * Fetch Account Details data show
   */
  fetchAccountRevenueTotal: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout-master/account-revenue/${id}`,
      {
        ...parameters,
      },
    );
  },
};
